// @flow
import { Plus } from '@phosphor-icons/react'
import { Button } from 'antd'
import * as React from 'react'
import type { ConditionalRuleGroup as ConditionalRuleGroupType } from 'types/conditional-rule-group'

import cn from '@/utils/tailwind/cn'

import ConditionalRule from './ConditionalRule'

type Props = {
  conditionalRuleGroup: ConditionalRuleGroupType,
  addRule: (groupId: string) => void,
  updateRule: (
    groupId: string,
    ruleId: string,
    key: string,
    value: string
  ) => void,
  removeRule: (groupId: string, ruleId: string) => void,
  updateLogicalOperator: (
    groupId: string,
    ruleId: string,
    newLogicalOperator: 'AND' | 'OR'
  ) => void,
  isLastGroup: boolean,
  isDirty: boolean,
  groupPosition: number,
}

function ConditionalRuleGroup({
  conditionalRuleGroup,
  addRule,
  updateRule,
  removeRule,
  updateLogicalOperator,
  isLastGroup,
  isDirty,
  groupPosition,
}: Props): React.Node {
  const rules = conditionalRuleGroup.conditional_rules ?? []

  return (
    <div
      className={cn(
        'w-full rounded pl-4 pr-2 pt-7',
        isLastGroup && 'pb-7',
        groupPosition && 'pt-0'
      )}
    >
      {rules.map((rule, index) => (
        <ConditionalRule
          addRule={addRule}
          groupId={conditionalRuleGroup.id}
          groupPosition={groupPosition}
          isDirty={isDirty}
          isLast={index + 1 === rules.length}
          key={rule.id}
          removeRule={removeRule}
          rule={rule}
          rulePosition={index}
          updateLogicalOperator={updateLogicalOperator}
          updateRule={updateRule}
        />
      ))}
      {isLastGroup ? (
        <Button
          className="border-primary bg-gray-50 text-sm text-primary hover:!bg-primary/5"
          onClick={() => addRule(conditionalRuleGroup.id)}
        >
          <Plus weight="bold" /> Add Condition
        </Button>
      ) : null}
    </div>
  )
}

export default ConditionalRuleGroup
